const common = {
  // Nav
  nav_home: 'Accueil',
  nav_books: 'Livres',
  nav_courses: 'Cours',
  nav_mentorship: 'Mentoria SÍLEX',
  nav_webinars: 'Webinaires',
  nav_about: 'À propos',
  nav_contact: 'Contact',
  nav_links: 'Liens',
  nav_enter: 'Se connecter',
  nav_my_courses: 'Mes Cours',
  nav_community: 'Communauté',
  nav_ranking: 'Classement',
  nav_certificates: 'Certificats',
  // Auth
  auth_login_title: 'Accédez à votre compte',
  auth_login_subtitle: 'Connectez-vous avec email ou réseaux sociaux',
  auth_register_title: 'Créer votre compte',
  auth_register_subtitle: 'Inscrivez-vous pour accéder aux cours',
  auth_forgot_title: 'Récupérer le mot de passe',
  auth_forgot_subtitle: 'Nous enverrons un lien à votre email',
  auth_tab_login: 'Se connecter',
  auth_tab_register: 'Créer un compte',
  auth_email: 'E-mail',
  auth_password: 'Mot de passe',
  auth_name: 'Nom complet',
  auth_confirm_password: 'Confirmer le mot de passe',
  auth_forgot_link: 'Mot de passe oublié',
  auth_btn_login: 'Se connecter avec Email',
  auth_btn_register: 'Créer un compte gratuit',
  auth_btn_forgot: 'Envoyer le lien de récupération',
  auth_or: 'ou continuer avec',
  auth_or_register: 'ou s\'inscrire avec',
  auth_google: 'Continuer avec Google',
  auth_facebook: 'Continuer avec Facebook',
  auth_apple: 'Continuer avec Apple',
  auth_back_login: '← Retour à la connexion',
  auth_terms: 'En vous connectant, vous acceptez nos',
  auth_terms_link: 'Conditions d\'utilisation',
  auth_privacy_link: 'Politique de confidentialité',
  auth_and: 'et',
  // Livros page
  livros_hero_badge: 'Bibliothèque Complète',
  livros_hero_title: 'Ebooks et Livres',
  livros_hero_subtitle: 'La connaissance qui transforme. Choisissez votre prochain livre et commencez votre voyage.',
  livros_filter_all: 'Tous',
  livros_filter_pdf: 'E-book PDF',
  livros_filter_print: 'Imprimé',
  livros_search_placeholder: 'Rechercher un livre ou un sujet...',
  livros_btn_buy: 'Acheter Maintenant',
  livros_btn_amazon: 'Amazon',
  livros_btn_details: 'Voir les Détails',
  livros_pages: 'pages',
  livros_readers: 'lecteurs',
  livros_cta_title: 'Accès à tous les livres ?',
  livros_cta_subtitle: 'Abonnez-vous à SB Family et obtenez un accès illimité à toute la bibliothèque + cours + mentorat de groupe.',
  livros_cta_btn: 'Découvrir l\'abonnement',
  livros_stat_books: 'Livres Publiés',
  livros_stat_readers: 'Lecteurs Satisfaits',
  livros_stat_rating: 'Note Moyenne',
  livros_stat_editions: 'Éditions Révisées',
  // Language
  lang_label: 'Langue',
  lang_pt: 'Português',
  lang_es: 'Español',
  lang_en: 'English',
  lang_fr: 'Français',
  lang_de: 'Deutsch',
  lang_it: 'Italiano',
  lang_ja: 'Japonais',
};

export default common;
